import * as PodravkaClient from '@hmn/podravkaio';
import { ImageMetadataUpdate, ApiClient } from '@hmn/podravkaio';
import Pluralize from 'pluralize';
import PathToRegex from 'path-to-regex';
import camelcase from 'camelcase';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * Service used for accesing and manipulating azure blob storage
 *
 * @returns
 */
var createAzureStorageService = function createAzureStorageService() {
  var instance = {};
  /**
   * Extract tokens from full storage container url
   *
   * @param {*} url
   * @returns
   */

  var tokenizeContainerUrl = function tokenizeContainerUrl(url) {
    var protocolSeparator = '//';
    var querySeparator = '?';
    var separator = '/';
    var protocolIndex = url.indexOf(protocolSeparator);
    var hostIndex = url.indexOf(separator, protocolIndex + protocolSeparator.length);
    var containerIndex = url.indexOf(separator, hostIndex + separator.length);
    var blobIndex = url.indexOf(querySeparator);
    return {
      host: url.substring(0, hostIndex),
      container: url.substring(hostIndex + separator.length, containerIndex),
      blob: url.substring(containerIndex + separator.length, blobIndex),
      sas: url.substring(blobIndex + querySeparator.length)
    };
  };
  /**
   * Upload file to azure blob storage
   *
   * @param {Object} { id, resource, file, uploadLocation: containerUrl }
   */


  var upload = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var id, resource, file, containerUrl, BlobServiceClient, _tokenizeContainerUrl, host, container, blob, sas, blobServiceClient, containerClient, blockBlobClient;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = _ref.id, resource = _ref.resource, file = _ref.file, containerUrl = _ref.uploadLocation;

              if (file === null || file === void 0 ? void 0 : file.rawFile) {
                _context.next = 3;
                break;
              }

              throw new Error('Item provided for upload is not a valid File');

            case 3:
              BlobServiceClient = instance.azureStorage.BlobServiceClient;
              _tokenizeContainerUrl = tokenizeContainerUrl(containerUrl), host = _tokenizeContainerUrl.host, container = _tokenizeContainerUrl.container, blob = _tokenizeContainerUrl.blob, sas = _tokenizeContainerUrl.sas;
              blobServiceClient = new BlobServiceClient("".concat(host, "?").concat(sas));
              containerClient = blobServiceClient.getContainerClient(container);
              blockBlobClient = containerClient.getBlockBlobClient(blob);
              _context.prev = 8;
              _context.next = 11;
              return blockBlobClient.uploadBrowserData(file.rawFile);

            case 11:
              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](8);
              // eslint-disable-next-line no-console
              console.error(_context.t0);
              throw new Error('Upload failed', _context.t0.message);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 13]]);
    }));

    return function upload(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return Object.freeze({
    /**
     * Init method, expects some Azure storage implementation
     * (for example blob storage)
     *
     * @param {Object} { azureStorage }
     */
    init: function init(_ref3) {
      var azureStorage = _ref3.azureStorage;
      instance.azureStorage = azureStorage;
    },
    upload: upload,
    isEnabled: function isEnabled() {
      return !!instance.azureStorage;
    }
  });
};

var AzureStorageService = createAzureStorageService();

/**
 * Bare resource client
 *
 * Should be extended by any base client (like default)
 * auto throws if any of the methods needed is not implemented
 * mostly here for better dev experience
 */
var bareClient = {
  getList: function getList(resource, params) {
    throw new Error('getList method is not supported');
  },
  getOne: function getOne(resource, params) {
    throw new Error('getOne method is not supported');
  },
  create: function create(resource, params) {
    throw new Error('create method is not supported');
  },
  update: function update(resource, params) {
    throw new Error('update method is not supported');
  },
  "delete": function _delete(resource, params) {
    throw new Error('delete method is not supported');
  },
  getUserPasswordResetToken: function getUserPasswordResetToken(resource, params) {
    throw new Error('getUserPasswordResetToken method is not supported');
  },
  resetUserPassword: function resetUserPassword(resource, params) {
    throw new Error('resetUserPassword method is not supported');
  }
};
var bareClient$1 = Object.freeze(bareClient);

var isNumeric = function isNumeric(n) {
  return n !== '' && n !== null && !Array.isArray(n) && !Number.isNaN(+n) && Number.isFinite(+n);
};

var CONTAINS = 'CONTAINS';
var STARTS_WITH = 'STARTS_WITH';
var ENDS_WITH = 'ENDS_WITH';
var NOT_CONTAINS = 'NOT_CONTAINS';
var NOT_STARTS_WITH = 'NOT_STARTS_WITH';
var NOT_ENDS_WITH = 'NOT_ENDS_WITH';
var COMPARISON_OPERATOR = Object.freeze({
  LOWER_THEN: '<',
  LOWER_THEN_OR_EQUAL: '<=',
  NOT_EQUAL: '<>',
  HIGHER_THEN: '>',
  HIGHER_THEN_OR_EQUAL: '>='
});
var SUPPORTED_COMPARISON_OPERATORS = Object.freeze(Object.values(COMPARISON_OPERATOR).reduce(function (acc, value) {
  acc[value] = true;
  return acc;
}, {}));
var PATTERN_MATCHER = {
  CONTAINS: '~*',
  STARTS_WITH: '~>',
  ENDS_WITH: '~<',
  EQUAL: '~=',
  NOT_CONTAINS: '~!=',
  NOT_STARTS_WITH: '~!>',
  NOT_ENDS_WITH: '~!<',
  NOT_EQUAL: '~!='
};
var LOGICAL_CASE = {
  AND: '&',
  OR: '*'
};
var SearchEnum = {
  CONTAINS: CONTAINS,
  STARTS_WITH: STARTS_WITH,
  ENDS_WITH: ENDS_WITH,
  NOT_CONTAINS: NOT_CONTAINS,
  NOT_STARTS_WITH: NOT_STARTS_WITH,
  NOT_ENDS_WITH: NOT_ENDS_WITH,
  COMPARISON_OPERATOR: COMPARISON_OPERATOR,
  SUPPORTED_COMPARISON_OPERATORS: SUPPORTED_COMPARISON_OPERATORS,
  PATTERN_MATCHER: PATTERN_MATCHER,
  LOGICAL_CASE: LOGICAL_CASE
};
var defaultMappings = {};
/**
 * SearchQuery parser for Rollerworks Search
 * https://rollerworkssearch.readthedocs.io/en/latest/reference/input/string_query.html
 *
 *
 *
 * @param {*} mappings
 * @returns {object}
 */

function SearchQuery() {
  var mappings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var instance = {
    mappings: mappings
  };
  /**
   * Apply default logical case (OR|AND) to expressions that require it
   *
   * @param {*} search
   * @param {*} logicalCase
   * @returns {string}
   */

  var applyLogicalCase = function applyLogicalCase(search, logicalCase) {
    var operator = LOGICAL_CASE[logicalCase];

    if (!operator) {
      throw new Error("LogicalCase ".concat(operator, " is not supported"));
    }

    if (operator !== LOGICAL_CASE.AND) {
      return "".concat(operator).concat(search);
    }

    return search;
  };
  /**
   * Stringify fields of search object
   *
   * @param {Object} fields
   * @returns {string}
   */


  var toStringFields = function toStringFields(fields) {
    return Object.keys(fields).reduce(function (currentFields, name) {
      var accFields = currentFields;
      var field = fields[name];

      if (accFields === '') {
        accFields += "".concat(name, ":");
      } else {
        accFields += ";".concat(name, ":");
      }

      accFields += Object.keys(field).reduce(function (acc, key) {
        var stringSearch = '';
        var values = field[key];

        switch (key) {
          case 'simple-values':
            stringSearch += values.reduce(function (currentString, value) {
              var accString = currentString;

              if (accString !== '') {
                accString += ',';
              }

              if (value.indexOf(' ') > -1) {
                accString += JSON.stringify(value);
              } else {
                accString += value;
              }

              return accString;
            }, '');
            break;

          case 'excluded-values':
            stringSearch += values.reduce(function (currentString, value) {
              var accString = currentString;

              if (accString !== '') {
                accString += ',';
              }

              if (value.indexOf(' ') > -1) {
                accString += "!".concat(JSON.stringify(value));
              } else {
                accString += "!".concat(value);
              }

              return accString;
            }, '');
            break;

          case 'ranges':
            stringSearch += values.reduce(function (currentString, range) {
              var accString = currentString;

              if (accString !== '') {
                accString += ',';
              }

              var lower = range.lower,
                  upper = range.upper;

              if (!isNumeric(lower) || !isNumeric(upper)) {
                throw new Error("Ranges only accept numeric values");
              }

              accString += "".concat(lower, "-").concat(upper);
              return accString;
            }, '');
            break;

          case 'excluded-ranges':
            stringSearch += values.reduce(function (currentString, range) {
              var accString = currentString;

              if (accString !== '') {
                accString += ',';
              }

              var lower = range.lower,
                  upper = range.upper;

              if (!isNumeric(lower) || !isNumeric(upper)) {
                throw new Error("Ranges only accept numeric values");
              }

              accString += "!".concat(lower, "-").concat(upper);
              return accString;
            }, '');
            break;

          case 'comparisons':
            stringSearch += values.reduce(function (currentString, comparison) {
              var accString = currentString;
              var value = comparison.value,
                  operator = comparison.operator;

              if (accString !== '') {
                accString += ',';
              }

              if (!SUPPORTED_COMPARISON_OPERATORS[operator]) {
                throw new Error("Operator '".concat(operator, "' is not supported"));
              }

              accString += operator;

              if (value.indexOf(' ') > -1) {
                accString += "".concat(JSON.stringify(value));
              } else {
                accString += "".concat(value);
              }

              return accString;
            }, '');
            break;

          case 'pattern-matchers':
            stringSearch += values.reduce(function (currentString, pattern) {
              var accString = currentString;
              var value = pattern.value,
                  type = pattern.type;

              if (accString !== '') {
                accString += ',';
              }

              if (!PATTERN_MATCHER[type]) {
                throw new Error("PatternMatcher type '".concat(type, "' is not supported"));
              }

              accString += PATTERN_MATCHER[type];

              if (value.indexOf(' ') > -1) {
                accString += "".concat(JSON.stringify(value));
              } else {
                accString += "".concat(value);
              }

              return accString;
            }, '');
            break;

          default:
            throw new Error("Key '".concat(key, "' is not valid inside StringQuery.field object"));
        }

        if (acc !== '' && stringSearch !== '') {
          return "".concat(acc, ",").concat(stringSearch);
        }

        return "".concat(acc).concat(stringSearch);
      }, '');
      return accFields;
    }, '');
  };
  /**
   * Stringify groups of search object
   *
   * @param {Array} groups
   * @returns {string}
   */


  var toStringGroups = function toStringGroups(groups) {
    return groups.reduce(function (currentGroup, group) {
      var accGroup = currentGroup;

      if (accGroup !== '') {
        accGroup += ';';
      }

      var groupString = Object.keys(group).reduce(function (acc, key) {
        var stringSearch = '';

        switch (key) {
          case 'fields':
            stringSearch += toStringFields(group.fields);
            break;

          case 'groups':
            stringSearch += toStringGroups(group.groups);
            break;

          case 'logical-case':
            // logical case is applied at the end
            break;

          default:
            throw new Error("Field '".concat(key, "' is not valid inside StringQuery.group format"));
        }

        if (acc !== '' && stringSearch !== '') {
          return "".concat(acc, ",").concat(stringSearch);
        }

        return "".concat(acc).concat(stringSearch);
      }, '');
      groupString = "(".concat(groupString, ")");
      groupString = applyLogicalCase(groupString, group['logical-case']);
      accGroup += groupString;
      return accGroup;
    }, '');
  };
  /**
   * Takes query object and turns it into valid SearchQuery object
   * with field mappings applied
   *
   * @param {object} query
   * @param {string} resource
   * @param {object} sort
   * @param {string} [logicalCase='AND']
   * @returns {Object}
   */


  var toObject = function toObject(query, resource, sort) {
    var logicalCase = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'AND';
    var nonEmptyQuery = query || {};
    var mapping = instance.mappings[resource] || defaultMappings;

    if (!mapping) {
      throw new Error("Mapping for resource (resource) does not exist!");
    }

    var result = Object.keys(nonEmptyQuery).reduce(function (acc, key) {
      var value = nonEmptyQuery[key];

      if (typeof value === 'undefined' || value === '') {
        return acc;
      }

      var mapValue = mapping[key];

      if (mapValue) {
        var _mapValue = mapValue(value),
            group = _mapValue.group,
            groups = _mapValue.groups,
            field = _mapValue.field,
            fields = _mapValue.fields;

        if (group) {
          acc.groups.push(group);
        }

        if (groups) {
          acc.groups = [].concat(_toConsumableArray(acc.groups), _toConsumableArray(groups));
        }

        if (field) {
          acc.fields[key] = field;
        }

        if (fields) {
          acc.fields = _objectSpread2(_objectSpread2({}, acc.fields), fields);
        }
      } else {
        acc.fields[key] = {
          'simple-values': Array.isArray(value) ? value : [value]
        };
      }

      return acc;
    }, {
      fields: {},
      groups: [],
      'logical-case': logicalCase
    });

    if (sort) {
      result.order = _defineProperty({}, sort.field, sort.order || 'ASC');
    }

    return result;
  };
  /**
   * Returns JSON representation of string query object
   *
   * @param {Object} query
   * @param {string} resource
   * @param {Object} sort
   * @param {string} [logicalCase='AND']
   * @returns {string}
   */


  var toJSON = function toJSON(query, resource, sort) {
    var logicalCase = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'AND';
    var searchObject = toObject(query, resource, sort, logicalCase);

    if (!searchObject) {
      return null;
    }

    return JSON.stringify(searchObject);
  };
  /**
   * Returns valid SearchQuery string
   *
   * @param {Object} query
   * @param {string} resource
   * @param {Object} sort
   * @param {string} [logicalCase='AND']
   * @returns {string}
   */


  var toString = function toString(query, resource, sort) {
    var logicalCase = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'AND';
    var searchObject = toObject(query, resource, sort, logicalCase);

    if (!searchObject) {
      return null;
    }

    var result = Object.keys(searchObject).reduce(function (acc, key) {
      var stringSearch = '';

      switch (key) {
        case 'fields':
          stringSearch += toStringFields(searchObject.fields);
          break;

        case 'groups':
          stringSearch += toStringGroups(searchObject.groups);
          break;

        case 'logical-case':
          // logical case is applied at the end
          break;

        case 'order':
          {
            var field = sort.field,
                order = sort.order;
            stringSearch += "@".concat(field, ":").concat(order);
            break;
          }

        default:
          throw new Error("Field '".concat(key, "' is not valid inside StringQuery format"));
      }

      if (acc !== '' && stringSearch !== '') {
        return "".concat(acc, ";").concat(stringSearch);
      }

      return "".concat(acc).concat(stringSearch);
    }, '');

    if (searchObject['logical-case']) {
      result = applyLogicalCase(result, searchObject['logical-case']);
    }

    return result;
  };

  return Object.freeze({
    toJSON: toJSON,
    toObject: toObject,
    toString: toString
  });
}

var capitalize = function capitalize(text) {
  return text.replace(/^\w/, function (c) {
    return c.toUpperCase();
  });
};

var resourceFormatMapping = {
  attributes: 'AttributeDefinition',
  bags: 'Taxonomy',
  'aspect-ratios': 'AspectRatio'
};
/**
 * Get pascal cased version of resource name
 *
 * @param {*} text
 * @returns {string}
 */

var formatResourceName = function formatResourceName(text) {
  var resource = text;
  var entityResource = text.split('/');

  if (entityResource.length > 1) {
    resource = entityResource[0];
  }

  return resourceFormatMapping[resource] ? resourceFormatMapping[resource] : capitalize(Pluralize.singular(resource));
};

var resourceModelNameMapping = {
  attributes: 'AttributeDefinition',
  'taxonomies/bags': 'TaxonBag',
  'aspect-ratios': 'AspectRatio'
};

var formatResourceModelName = function formatResourceModelName(text) {
  var resource = text;
  var entityResource = text.split('/');

  if (!resourceModelNameMapping[resource] && entityResource.length > 1) {
    resource = entityResource[0];
  }

  return resourceModelNameMapping[resource] ? resourceModelNameMapping[resource] : capitalize(Pluralize.singular(resource));
};
/**
 * Custom error parser because SDK is not parsing error to data
 *
 * @param {*} originalError
 * @param {*} response
 * @returns {object}
 */


var errorParser = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(originalError, response) {
    var _response$body;

    var error;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            error = originalError;
            error.status = (response === null || response === void 0 ? void 0 : response.status) || 'unknown';
            _context.t0 = error.status;
            _context.next = _context.t0 === 401 ? 5 : _context.t0 === 403 ? 7 : 9;
            break;

          case 5:
            error.message = 'Token not valid or expired, please login again';
            return _context.abrupt("break", 10);

          case 7:
            error.message = 'You are not allowed to access this resource';
            return _context.abrupt("break", 10);

          case 9:
            error.message = (response === null || response === void 0 ? void 0 : (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.detail) || (originalError === null || originalError === void 0 ? void 0 : originalError.message) || 'Unknown error';

          case 10:
            return _context.abrupt("return", originalError);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function errorParser(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var createPayloadHandler = function createPayloadHandler(resource, params) {
  try {
    return [params.language, PodravkaClient[["".concat(formatResourceModelName(resource), "Create")]].constructFromObject(params.data || {})];
  } catch (e) {
    throw new Error("Create model for resource '".concat(resource, "' does not exist"));
  }
};

var updatePayloadHandler = function updatePayloadHandler(resource, params) {
  try {
    var _params$data;

    if (((_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.extended_attributes) === null) {
      // eslint-disable-next-line camelcase
      params.data.extended_attributes = {};
    }

    return [params.language, params.id, PodravkaClient[["".concat(formatResourceModelName(resource), "Update")]].constructFromObject(params.data || {})];
  } catch (e) {
    throw new Error("Update model for resource '".concat(resource, "' does not exist"));
  }
};

/**
 * Default resource client
 *
 * Provides data provider methods for any resource that does not require custom client
 * also can used as base for any other client
 */

var defaultClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  getList: function getList(resource, params) {
    var _params$pagination;

    var searchService = new SearchQuery(params.searchMappings);
    return {
      method: "get".concat(formatResourceModelName(resource), "List"),
      args: [params.language, _objectSpread2(_objectSpread2({
        page: ((_params$pagination = params.pagination) === null || _params$pagination === void 0 ? void 0 : _params$pagination.page) || 1,
        search: params.search || searchService.toString(params.filter, resource, params.sort)
      }, params.filter), params.opts)],
      onData: function onData(data, response) {
        var _response$headers$con;

        var total = parseInt((_response$headers$con = response.headers['content-range']) === null || _response$headers$con === void 0 ? void 0 : _response$headers$con.split('/').pop(), 10); // parseInt is either gonna return a number, NaN, or throw an Error

        if (Number.isNaN(total)) {
          // eslint-disable-next-line no-console
          console.warn('content-range header is missing, using response length as total');
        }

        return {
          response: response,
          data: data,
          total: total || data.length
        };
      },
      onError: errorParser
    };
  },
  getOne: function getOne(resource, params) {
    return {
      method: "get".concat(formatResourceModelName(resource)),
      args: [params.language, params.id],
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData(_x, _x2) {
          return _onData.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  create: function create(resource, params) {
    return {
      method: "create".concat(formatResourceModelName(resource)),
      args: createPayloadHandler(resource, params),
      onData: function () {
        var _onData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, response) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onData(_x3, _x4) {
          return _onData2.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  update: function update(resource, params) {
    return {
      method: "update".concat(formatResourceModelName(resource)),
      args: updatePayloadHandler(resource, params),
      onData: function () {
        var _onData3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, response) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function onData(_x5, _x6) {
          return _onData3.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  "delete": function _delete(resource, params) {
    return {
      method: "delete".concat(formatResourceModelName(resource)),
      args: [params.id],
      onData: function () {
        var _onData4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data, response) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", {
                    response: response,
                    data: data || {
                      id: params.id
                    }
                  });

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function onData(_x7, _x8) {
          return _onData4.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  }
});

var defaultClient$1 = Object.freeze(defaultClient);

var getEntity = function getEntity(resource) {
  var resourceParts = resource.split('/');

  if (resourceParts.length > 1) {
    return resourceParts[1];
  }

  throw new Error("Could not extract attribute entity from resource '".concat(resource, "'"));
};
/**
 * AttributeDefinition client
 *
 * Provides data provider methods for managing attributes for different resources
 */


var attributeClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  getList: function getList(resource, params) {
    var _defaultClient$getLis = defaultClient$1.getList(resource, params),
        args = _defaultClient$getLis.args,
        rest = _objectWithoutProperties(_defaultClient$getLis, ["args"]);

    var _args = _toArray(args),
        _acceptLanguage = _args[0],
        restArgs = _args.slice(1);

    return _objectSpread2(_objectSpread2({}, rest), {}, {
      args: [getEntity(resource)].concat(_toConsumableArray(restArgs))
    });
  },
  getOne: function getOne(resource, params) {
    var _defaultClient$getOne = defaultClient$1.getOne(resource, params),
        args = _defaultClient$getOne.args,
        rest = _objectWithoutProperties(_defaultClient$getOne, ["args"]);

    var _args2 = _toArray(args),
        _acceptLanguage = _args2[0],
        restArgs = _args2.slice(1);

    return _objectSpread2(_objectSpread2({}, rest), {}, {
      args: [getEntity(resource)].concat(_toConsumableArray(restArgs))
    });
  },
  create: function create(resource, params) {
    var _defaultClient$create = defaultClient$1.create(resource, params),
        args = _defaultClient$create.args,
        rest = _objectWithoutProperties(_defaultClient$create, ["args"]);

    var _args3 = _toArray(args),
        _acceptLanguage = _args3[0],
        restArgs = _args3.slice(1);

    return _objectSpread2(_objectSpread2({}, rest), {}, {
      args: [getEntity(resource)].concat(_toConsumableArray(restArgs))
    });
  },
  "delete": function _delete(resource, params) {
    var _defaultClient$delete = defaultClient$1["delete"](resource, params),
        args = _defaultClient$delete.args,
        rest = _objectWithoutProperties(_defaultClient$delete, ["args"]);

    return _objectSpread2(_objectSpread2({}, rest), {}, {
      args: [getEntity(resource)].concat(_toConsumableArray(args))
    });
  }
});

var attributeClient$1 = Object.freeze(attributeClient);

/**
 * Comment client
 *
 * Provides access to subresources and methods specific to comments resource
 */

var commentClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  getList: function getList(resource, params) {
    var _params$pagination;

    var searchService = new SearchQuery(params.searchMappings);
    return {
      method: "getCommentCollection",
      args: [params.language, _objectSpread2(_objectSpread2({
        page: ((_params$pagination = params.pagination) === null || _params$pagination === void 0 ? void 0 : _params$pagination.page) || 1,
        search: params.search || searchService.toString(params.filter, resource, params.sort)
      }, params.filter), params.opts)],
      onData: function onData(data, response) {
        var _response$headers$con;

        var total = parseInt((_response$headers$con = response.headers['content-range']) === null || _response$headers$con === void 0 ? void 0 : _response$headers$con.split('/').pop(), 10); // parseInt is either gonna return a number, NaN, or throw an Error

        if (Number.isNaN(total)) {
          // eslint-disable-next-line no-console
          console.warn('content-range header is missing, using response length as total');
        }

        return {
          response: response,
          data: data,
          total: total || data.length
        };
      },
      onError: errorParser
    };
  },
  getOne: function getOne(resource, params) {
    var _resource$split = resource.split('/'),
        _resource$split2 = _slicedToArray(_resource$split, 2),
        entity = _resource$split2[0],
        entityId = _resource$split2[1];

    return {
      method: "get".concat(formatResourceModelName(entity), "Comment"),
      args: [params.language, entityId, params.id],
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!data.iri) {
                    data.iri = "/api/".concat(entity, "/").concat(entityId, "/comments/").concat(params.id);
                  }

                  return _context.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData(_x, _x2) {
          return _onData.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  create: function create(resource, params) {
    var _resource$split3 = resource.split('/'),
        _resource$split4 = _slicedToArray(_resource$split3, 2),
        entity = _resource$split4[0],
        entityId = _resource$split4[1];

    var body = params.data.body;
    return {
      method: "create".concat(formatResourceModelName(entity), "Comment"),
      args: [params.language, entityId, {
        body: body
      }],
      onData: function () {
        var _onData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, response) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!data.iri) {
                    data.iri = "/api/".concat(entity, "/").concat(entityId, "/comments/").concat(data.id);
                  }

                  return _context2.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onData(_x3, _x4) {
          return _onData2.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  update: function update(resource, params) {
    var _resource$split5 = resource.split('/'),
        _resource$split6 = _slicedToArray(_resource$split5, 2),
        entity = _resource$split6[0],
        entityId = _resource$split6[1];

    var body = params.data.body;
    return {
      method: "update".concat(formatResourceModelName(entity), "Comment"),
      args: [params.language, entityId, params.id, {
        body: body
      }],
      onData: function () {
        var _onData3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, response) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!data.iri) {
                    data.iri = "/api/".concat(entity, "/").concat(entityId, "/comments/").concat(params.id);
                  }

                  return _context3.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function onData(_x5, _x6) {
          return _onData3.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  "delete": function _delete(resource, params) {
    var _resource$split7 = resource.split('/'),
        _resource$split8 = _slicedToArray(_resource$split7, 2),
        entity = _resource$split8[0],
        entityId = _resource$split8[1];

    return {
      method: "delete".concat(formatResourceModelName(entity), "Comment"),
      args: [entityId, params.id],
      onData: function () {
        var _onData4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data, response) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", {
                    response: response,
                    data: data || {
                      id: params.id,
                      iri: "/api/".concat(entity, "/").concat(entityId, "/comments/").concat(params.id)
                    }
                  });

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function onData(_x7, _x8) {
          return _onData4.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  }
});

var commentClient$1 = Object.freeze(commentClient);

/**
 * Upload file by using injected storageService module
 *
 * @param {*} resource
 * @param {*} params
 * @param {*} response
 * @param {*} data
 */

var upload = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resource, params, response, data) {
    var storageService, _response$headers$loc, uploadLocation;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            storageService = params.storageService;

            if (!(storageService.isEnabled() && params.data.file)) {
              _context.next = 6;
              break;
            }

            _response$headers$loc = response.headers.location, uploadLocation = _response$headers$loc === void 0 ? params.data.uploadLocation : _response$headers$loc;

            if (!uploadLocation) {
              _context.next = 6;
              break;
            }

            _context.next = 6;
            return storageService.upload({
              id: data.id,
              resource: resource,
              file: params.data.file,
              uploadLocation: uploadLocation
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function upload(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * File resource client (images/files/videos)
 *
 * Provides data provider methods for resources that support file upload
 */


var fileClient = _objectSpread2(_objectSpread2({}, defaultClient$1), {}, {
  getOne: function getOne(resource, params) {
    var _defaultClient$getOne = defaultClient$1.getOne(resource, params),
        _onData = _defaultClient$getOne.onData,
        rest = _objectWithoutProperties(_defaultClient$getOne, ["onData"]);

    return _objectSpread2(_objectSpread2({}, rest), {}, {
      onData: function () {
        var _onData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _response$headers;

          var _yield$_onData,
              response,
              data,
              _args2 = arguments;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _onData.apply(void 0, _args2);

                case 2:
                  _yield$_onData = _context2.sent;
                  response = _yield$_onData.response;
                  data = _yield$_onData.data;
                  data.uploadLocation = (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.location;
                  return _context2.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onData() {
          return _onData2.apply(this, arguments);
        }

        return onData;
      }()
    });
  },
  create: function create(resource, params) {
    var _defaultClient$create = defaultClient$1.create(resource, params),
        _onData3 = _defaultClient$create.onData,
        onError = _defaultClient$create.onError,
        rest = _objectWithoutProperties(_defaultClient$create, ["onData", "onError"]);

    return _objectSpread2(_objectSpread2({}, rest), {}, {
      onData: function () {
        var _onData4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var _yield$_onData2,
              response,
              data,
              _args3 = arguments;

          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _onData3.apply(void 0, _args3);

                case 2:
                  _yield$_onData2 = _context3.sent;
                  response = _yield$_onData2.response;
                  data = _yield$_onData2.data;
                  _context3.prev = 5;
                  _context3.next = 8;
                  return upload(resource, params, response, data);

                case 8:
                  _context3.next = 14;
                  break;

                case 10:
                  _context3.prev = 10;
                  _context3.t0 = _context3["catch"](5);
                  _context3.next = 14;
                  return onError(_context3.t0);

                case 14:
                  return _context3.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 15:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[5, 10]]);
        }));

        function onData() {
          return _onData4.apply(this, arguments);
        }

        return onData;
      }(),
      onError: onError
    });
  },
  update: function update(resource, params) {
    var _defaultClient$update = defaultClient$1.update(resource, params),
        _onData5 = _defaultClient$update.onData,
        onError = _defaultClient$update.onError,
        rest = _objectWithoutProperties(_defaultClient$update, ["onData", "onError"]);

    return _objectSpread2(_objectSpread2({}, rest), {}, {
      onData: function () {
        var _onData6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var _yield$_onData3,
              response,
              data,
              _args4 = arguments;

          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _onData5.apply(void 0, _args4);

                case 2:
                  _yield$_onData3 = _context4.sent;
                  response = _yield$_onData3.response;
                  data = _yield$_onData3.data;
                  _context4.prev = 5;
                  _context4.next = 8;
                  return upload(resource, params, response, data);

                case 8:
                  _context4.next = 14;
                  break;

                case 10:
                  _context4.prev = 10;
                  _context4.t0 = _context4["catch"](5);
                  _context4.next = 14;
                  return onError(_context4.t0);

                case 14:
                  return _context4.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 15:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[5, 10]]);
        }));

        function onData() {
          return _onData6.apply(this, arguments);
        }

        return onData;
      }(),
      onError: onError
    });
  }
});

var fileClient$1 = Object.freeze(fileClient);

var matchPath = new PathToRegex('images/:subresource(metadata)?');

var match = function match(resource, params) {
  var matchResult = matchPath.match(resource);
  return !!matchResult;
};
/**
 * Image client
 *
 * Provides access to subresources and methods specific to images resource
 */


var imageClient = _objectSpread2(_objectSpread2({}, fileClient$1), {}, {
  getOne: function getOne(resource, params) {
    var result = fileClient$1.getOne(resource, params);

    var _ref = matchPath.match(resource, params) || {},
        subresource = _ref.subresource;

    if (!subresource) {
      return result;
    }

    return _objectSpread2(_objectSpread2({}, result), {}, {
      method: "getImage".concat(capitalize(subresource)),
      args: [params.id],
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _yield$result$onData,
              data,
              rest,
              _args = arguments;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return result.onData.apply(result, _args);

                case 2:
                  _yield$result$onData = _context.sent;
                  data = _yield$result$onData.data;
                  rest = _objectWithoutProperties(_yield$result$onData, ["data"]);
                  data.id = params.id;
                  return _context.abrupt("return", _objectSpread2(_objectSpread2({}, rest), {}, {
                    data: data
                  }));

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData() {
          return _onData.apply(this, arguments);
        }

        return onData;
      }()
    });
  },
  update: function update(resource, params) {
    var result = fileClient$1.update(resource, params);

    var _ref2 = matchPath.match(resource, params) || {},
        subresource = _ref2.subresource;

    if (!subresource) {
      return result;
    }

    return _objectSpread2(_objectSpread2({}, result), {}, {
      method: "setImage".concat(capitalize(subresource)),
      args: [params.id, ImageMetadataUpdate.constructFromObject(params.data || {})],
      onData: function () {
        var _onData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _yield$result$onData2,
              data,
              rest,
              _args2 = arguments;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return result.onData.apply(result, _args2);

                case 2:
                  _yield$result$onData2 = _context2.sent;
                  data = _yield$result$onData2.data;
                  rest = _objectWithoutProperties(_yield$result$onData2, ["data"]);
                  data.id = params.id;
                  return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, rest), {}, {
                    data: data
                  }));

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onData() {
          return _onData2.apply(this, arguments);
        }

        return onData;
      }()
    });
  }
});
var imageClient$1 = Object.freeze(imageClient);

/* eslint-disable no-useless-escape, prettier/prettier */

var formatConfigModelName = function formatConfigModelName(text) {
  var resourceParts = text.split('/');

  if (resourceParts.length > 2) {
    var _resourceParts = _slicedToArray(resourceParts, 3),
        resource = _resourceParts[0],
        configName = _resourceParts[1],
        configEntity = _resourceParts[2];

    return "".concat(formatResourceName(resource)).concat(formatResourceName(configName)).concat(formatResourceName(configEntity));
  }

  throw new Error("Could not extract model name from resource '".concat(text, "'"));
};
/* eslint-enable no-useless-escape, prettier/prettier */

/**
 * images/config resource client
 *
 * Provides data provider methods for fetching images/config
 *
 */


var configClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  getList: function getList(resource, params) {
    var _params$pagination;

    return {
      method: "get".concat(formatConfigModelName(resource), "List"),
      args: [{
        page: ((_params$pagination = params.pagination) === null || _params$pagination === void 0 ? void 0 : _params$pagination.page) || 1
      }],
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData(_x, _x2) {
          return _onData.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  getOne: function getOne(resource, params) {
    return {
      method: "get".concat(formatConfigModelName(resource)),
      args: [params.id],
      onData: function () {
        var _onData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, response) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onData(_x3, _x4) {
          return _onData2.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  create: function create(resource, params) {
    return {
      method: "create".concat(formatConfigModelName(resource)),
      args: [PodravkaClient[["".concat(formatConfigModelName(resource), "Create")]].constructFromObject(params.data || {})],
      onData: function () {
        var _onData3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, response) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function onData(_x5, _x6) {
          return _onData3.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  update: function update(resource, params) {
    return {
      method: "update".concat(formatConfigModelName(resource)),
      args: [params.id, PodravkaClient[["".concat(formatConfigModelName(resource), "Update")]].constructFromObject(params.data || {})],
      onData: function () {
        var _onData4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data, response) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function onData(_x7, _x8) {
          return _onData4.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  "delete": function _delete(resource, params) {
    return {
      method: "delete".concat(formatConfigModelName(resource)),
      args: [params.id],
      onData: function () {
        var _onData5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(data, response) {
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        function onData(_x9, _x10) {
          return _onData5.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  }
});

var configClient$1 = Object.freeze(configClient);

var getTaxonomy = function getTaxonomy(resource) {
  var resourceParts = resource.split('/');

  if (resourceParts.length > 1) {
    return resourceParts[1];
  }

  throw new Error("Could not extract taxonomy bag from resource '".concat(resource, "'"));
};

var formatTaxonModelName = function formatTaxonModelName(resource) {
  var resourceParts = resource.split('/');

  switch (resourceParts[0]) {
    case 'sitemaps':
      return 'SitemapNode';

    default:
      return 'Taxon';
  }
};
/**
 * Taxonomy resource client
 *
 * Provides data provider methods for taxonomy resources (includes sitemap specialization)
 * Also manages taxon based operations
 */


var taxonomyClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  getList: function getList(resource, params) {
    var _params$pagination;

    var searchService = new SearchQuery(_objectSpread2(_defineProperty({}, resource, params.searchMappings.taxons), params.searchMappings));
    return {
      method: "get".concat(formatTaxonModelName(resource), "List"),
      args: [params.language, getTaxonomy(resource), _objectSpread2(_objectSpread2({
        page: ((_params$pagination = params.pagination) === null || _params$pagination === void 0 ? void 0 : _params$pagination.page) || 1,
        search: params.search || searchService.toString(params.filter, resource, params.sort)
      }, params.filter), params.opts)],
      onData: function onData(data, response) {
        var _response$headers$con;

        var total = parseInt((_response$headers$con = response.headers['content-range']) === null || _response$headers$con === void 0 ? void 0 : _response$headers$con.split('/').pop(), 10);

        if (Number.isNaN(total)) {
          // eslint-disable-next-line no-console
          console.warn('content-range header is missing, using response length as total');
        }

        return {
          response: response,
          data: data,
          total: total || data.length
        };
      },
      onError: errorParser
    };
  },
  getOne: function getOne(resource, params) {
    return {
      method: "get".concat(formatTaxonModelName(resource)),
      args: [params.language, getTaxonomy(resource), params.id],
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData(_x, _x2) {
          return _onData.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  create: function create(resource, params) {
    return {
      method: "create".concat(formatTaxonModelName(resource)),
      args: [params.language, getTaxonomy(resource), PodravkaClient[["".concat(formatTaxonModelName(resource), "Create")]].constructFromObject(params.data || {})],
      onData: function () {
        var _onData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, response) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onData(_x3, _x4) {
          return _onData2.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  update: function update(resource, params) {
    var _params$data, _params$data2;

    return {
      method: "update".concat(formatTaxonModelName(resource)),
      args: [params.language, getTaxonomy(resource), params.id, PodravkaClient[["".concat(formatTaxonModelName(resource), "Update")]].constructFromObject(_objectSpread2(_objectSpread2({}, params.data || {}), {}, {
        // eslint-disable-next-line camelcase
        extended_attributes: ((_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.extended_attributes) === null ? {} : (_params$data2 = params.data) === null || _params$data2 === void 0 ? void 0 : _params$data2.extended_attributes
      }))],
      onData: function () {
        var _onData3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, response) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function onData(_x5, _x6) {
          return _onData3.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  "delete": function _delete(resource, params) {
    return {
      method: "delete".concat(formatTaxonModelName(resource)),
      args: [getTaxonomy(resource), params.id],
      onData: function () {
        var _onData4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data, response) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", {
                    response: response,
                    data: data || {
                      id: params.id
                    }
                  });

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function onData(_x7, _x8) {
          return _onData4.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  }
});
var taxonomyClient$1 = Object.freeze(taxonomyClient);

var formatStateModelName = function formatStateModelName(text) {
  var modelName;

  if (text.startsWith('taxonomies/')) {
    modelName = formatTaxonModelName(text);
  } else {
    modelName = formatResourceModelName(text);
  }

  return modelName;
};
/**
 * State client
 *
 * Provides data provider methods for state based resource operations
 */


var stateClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  getOne: function getOne(resource, params) {
    var args = [params.language, params.id];

    if (resource.startsWith('taxonomies/')) {
      var taxonomy = getTaxonomy(resource);
      args.splice(1, 0, taxonomy);
    }

    return {
      method: "get".concat(formatStateModelName(resource), "State"),
      args: args,
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData(_x, _x2) {
          return _onData.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  update: function update(resource, params) {
    var args = [params.language, params.id, PodravkaClient["".concat(formatStateModelName(resource), "State")].constructFromObject(params.data)];

    if (resource === 'files/state') {
      args.push(params.opts);
    }

    if (resource.startsWith('taxonomies/')) {
      var taxonomy = getTaxonomy(resource);
      args.splice(1, 0, taxonomy);
    }

    return {
      method: "set".concat(formatStateModelName(resource), "State"),
      args: args,
      onData: function () {
        var _onData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, response) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onData(_x3, _x4) {
          return _onData2.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  }
});

var stateClient$1 = Object.freeze(stateClient);

/**
 * Tenant resource client
 *
 * Provides data provider methods for tenant resource
 */

var tenantClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  getOne: function getOne(resource, params) {
    return {
      method: "getCurrentTenantItem",
      args: [],
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData(_x, _x2) {
          return _onData.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  }
});

var tenantClient$1 = Object.freeze(tenantClient);

/**
 * User resource client
 *
 * Provides data provider methods for user resource
 */

var userClient = _objectSpread2(_objectSpread2({}, defaultClient$1), {}, {
  getList: function getList(resource, params) {
    var _defaultClient$getLis = defaultClient$1.getList(resource, params),
        args = _defaultClient$getLis.args,
        rest = _objectWithoutProperties(_defaultClient$getLis, ["args"]);

    var _args = _toArray(args),
        _acceptLanguage = _args[0],
        restArgs = _args.slice(1);

    return _objectSpread2(_objectSpread2({}, rest), {}, {
      method: 'getUserList',
      args: restArgs
    });
  },
  getOne: function getOne(resource, params) {
    var _defaultClient$getOne = defaultClient$1.getOne(resource, params),
        args = _defaultClient$getOne.args,
        rest = _objectWithoutProperties(_defaultClient$getOne, ["args"]);

    var _args2 = _toArray(args),
        _acceptLanguage = _args2[0],
        restArgs = _args2.slice(1);

    var hasId = !!params.id;
    return _objectSpread2(_objectSpread2({}, rest), {}, {
      method: hasId ? 'getUser' : 'getCurrentUserItem',
      args: hasId ? restArgs : []
    });
  },
  create: function create(resource, params) {
    throw new Error('create method is not supported');
  },
  update: function update(resource, params) {
    var _defaultClient$update = defaultClient$1.update(resource, params),
        args = _defaultClient$update.args,
        rest = _objectWithoutProperties(_defaultClient$update, ["args"]);

    var _args3 = _toArray(args),
        _acceptLanguage = _args3[0],
        restArgs = _args3.slice(1);

    return _objectSpread2(_objectSpread2({}, rest), {}, {
      args: restArgs
    });
  },
  "delete": function _delete(resource, params) {
    throw new Error('delete method is not supported');
  }
});

var userClient$1 = Object.freeze(userClient);

var tokenizeVersionResource = function tokenizeVersionResource(resource) {
  var resourceParts = resource.split('/');

  if (resourceParts.length < 3) {
    throw new Error("Could not extract entity from version resource '".concat(resource, "'"));
  }

  var result = {};

  switch (resourceParts[0]) {
    case 'sitemaps':
      result.model = 'SitemapNode';
      result.entity = resourceParts[1];
      result.entityId = resourceParts[2];
      break;

    case 'taxonomies':
      result.model = 'Taxon';
      result.entity = resourceParts[1];
      result.entityId = resourceParts[2];
      break;

    default:
      result.model = capitalize(Pluralize.singular(resourceParts[0]));
      result.entityId = resourceParts[1];
  } // if result.entity!==undefined (also truthy) that means that we are accessing
  // version of taxonomy based resource


  return result;
};
/**
 * Version resource client
 *
 * Provides data provider methods for version resource
 * Also handles taxonomy based entities version methods
 */


var versionClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  getList: function getList(resource, params) {
    var _params$pagination;

    var _tokenizeVersionResou = tokenizeVersionResource(resource),
        model = _tokenizeVersionResou.model,
        entity = _tokenizeVersionResou.entity,
        entityId = _tokenizeVersionResou.entityId;

    var args = [params.language, entityId, _objectSpread2({
      page: ((_params$pagination = params.pagination) === null || _params$pagination === void 0 ? void 0 : _params$pagination.page) || 1
    }, params.opts)];

    if (entity) {
      args.splice(1, 0, entity);
    }

    return {
      method: "get".concat(model, "VersionList"),
      args: args,
      onData: function onData(data, response) {
        var _response$headers$con;

        // TODO API does not return Content-Range header, remove when fixed
        // Issue https://app.productive.io/8988-human/tasks/974395
        var total = parseInt((_response$headers$con = response.headers['content-range']) === null || _response$headers$con === void 0 ? void 0 : _response$headers$con.split('/').pop(), 10);

        if (Number.isNaN(total)) {
          // eslint-disable-next-line no-console
          console.warn('content-range header is missing, using response length as total');
        }

        return {
          response: response,
          data: data,
          total: total || data.length
        };
      },
      onError: errorParser
    };
  },
  getOne: function getOne(resource, params) {
    var _tokenizeVersionResou2 = tokenizeVersionResource(resource),
        model = _tokenizeVersionResou2.model,
        entity = _tokenizeVersionResou2.entity,
        entityId = _tokenizeVersionResou2.entityId;

    var args = [entityId, params.id];

    if (entity) {
      args.unshift(entity);
    }

    return {
      method: "get".concat(model, "Version"),
      args: args,
      onData: function onData(data, response) {
        return {
          response: response,
          data: data
        };
      },
      onError: errorParser
    };
  },
  create: function create(resource, params) {
    var _tokenizeVersionResou3 = tokenizeVersionResource(resource),
        model = _tokenizeVersionResou3.model,
        entity = _tokenizeVersionResou3.entity,
        entityId = _tokenizeVersionResou3.entityId;

    var args = [params.language, entityId, PodravkaClient[["".concat(model, "VersionWrite")]].constructFromObject(params.data || {})];

    if (entity) {
      args.splice(1, 0, entity);
    }

    return {
      method: "create".concat(model, "Version"),
      args: args,
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData(_x, _x2) {
          return _onData.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  update: function update(resource, params) {
    var _tokenizeVersionResou4 = tokenizeVersionResource(resource),
        model = _tokenizeVersionResou4.model,
        entity = _tokenizeVersionResou4.entity,
        entityId = _tokenizeVersionResou4.entityId;

    var args = [entityId, params.id, PodravkaClient[["".concat(model, "VersionWrite")]].constructFromObject(params.data || {})];

    if (entity) {
      args.unshift(entity);
    }

    return {
      method: "update".concat(model, "Version"),
      args: args,
      onData: function () {
        var _onData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, response) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onData(_x3, _x4) {
          return _onData2.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  }
});
var versionClient$1 = Object.freeze(versionClient);

/**
 * Options client
 *
 * Provides data provider methods for options based resource operations
 */

var optionsClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  update: function update(resource, params) {
    var _tokenizeVersionResou = tokenizeVersionResource(resource),
        model = _tokenizeVersionResou.model,
        entity = _tokenizeVersionResou.entity,
        entityId = _tokenizeVersionResou.entityId;

    var args = [entityId, params.id, _defineProperty({}, camelcase(model), params.data.options)];

    if (entity) {
      args.splice(0, 0, entity);
    }

    return {
      method: "update".concat(model, "VersionOptions"),
      args: args,
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData(_x, _x2) {
          return _onData.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  }
});

var match$1 = function match(resource, params) {
  var isVersionResource = resource.indexOf('/versions') > -1;
  return isVersionResource && !!params.isOptions;
};
var optionsClient$1 = Object.freeze(optionsClient);

var contentTaxonClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  getList: function getList(resource, params) {
    var _params$pagination;

    var searchService = new SearchQuery(params.searchMappings);
    return {
      method: "getContent".concat(formatTaxonModelName(resource), "List"),
      args: [params.language, params.entity, params.entityId, params.bag || getTaxonomy(resource), _objectSpread2(_objectSpread2({
        page: ((_params$pagination = params.pagination) === null || _params$pagination === void 0 ? void 0 : _params$pagination.page) || 1,
        search: params.search || searchService.toString(params.filter, resource, params.sort)
      }, params.filter), params.opts)],
      onData: function onData(data, response) {
        var _response$headers$con;

        var total = parseInt((_response$headers$con = response.headers['content-range']) === null || _response$headers$con === void 0 ? void 0 : _response$headers$con.split('/').pop(), 10);

        if (Number.isNaN(total)) {
          // eslint-disable-next-line no-console
          console.warn('content-range header is missing, using response length as total');
        }

        return {
          response: response,
          data: data,
          total: total || data.length
        };
      },
      onError: errorParser
    };
  },
  getOne: function getOne(resource, params) {
    return {
      method: "getContent".concat(formatTaxonModelName(resource)),
      args: [params.language, params.entity, params.entityId, params.bag || getTaxonomy(resource), params.id],
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData(_x, _x2) {
          return _onData.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  create: function create(resource, params) {
    return {
      method: "createContent".concat(formatTaxonModelName(resource)),
      args: [params.language, params.entity, params.entityId, params.bag || getTaxonomy(resource), PodravkaClient[["Content".concat(formatTaxonModelName(resource), "Create")]].constructFromObject(params.data || {})],
      onData: function () {
        var _onData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, response) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onData(_x3, _x4) {
          return _onData2.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  "delete": function _delete(resource, params) {
    return {
      method: "deleteContent".concat(formatTaxonModelName(resource)),
      args: [params.entity, params.entityId, params.bag || getTaxonomy(resource), params.id],
      onData: function () {
        var _onData3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, response) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", {
                    response: response,
                    data: data || {
                      id: params.id
                    }
                  });

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function onData(_x5, _x6) {
          return _onData3.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  }
});

var matchPath$1 = new PathToRegex('/:entity/:entityId/taxons/:taxonBag');

var match$2 = function match(resource, params) {
  if (!params.entity || !params.entityId) {
    return false;
  }

  var _ref = matchPath$1.match("".concat(params.entity, "/").concat(params.entityId, "/taxons/").concat(params.bag || getTaxonomy(resource))) || {},
      entity = _ref.entity,
      entityId = _ref.entityId,
      taxonBag = _ref.taxonBag;

  return !!entity && !!entityId && !!taxonBag;
};
var contentTaxon = Object.freeze(contentTaxonClient);

var contentSitemapNodeClient = _objectSpread2(_objectSpread2({}, bareClient$1), contentTaxon);

var matchPath$2 = new PathToRegex('/:entity/:entityId/sitemaps/:sitemap/nodes');

var match$3 = function match(resource, params) {
  if (!params.entity || !params.entityId) {
    return false;
  }

  var _ref = matchPath$2.match("".concat(params.entity, "/").concat(params.entityId, "/").concat(resource, "/nodes")) || {},
      entity = _ref.entity,
      entityId = _ref.entityId,
      sitemap = _ref.sitemap;

  return !!entity && !!entityId && !!sitemap;
};
var contentSitemapNode = Object.freeze(contentSitemapNodeClient);

/**
 * Comment Options client
 *
 * Provides data provider methods for comment options based resource operations
 */

var commentOptionsClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  getOne: function getOne(resource, params) {
    var _tokenizeVersionResou = tokenizeVersionResource(resource),
        model = _tokenizeVersionResou.model;

    var args = [params.language, params.id];
    return {
      method: "get".concat(model, "CommentOptions"),
      args: args,
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
          var _data$constructor;

          var adjustedData;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  adjustedData = ((_data$constructor = data.constructor) === null || _data$constructor === void 0 ? void 0 : _data$constructor.constructFromObject({})) || {};
                  adjustedData.id = params.id;
                  adjustedData.options = _objectSpread2({}, data);
                  return _context.abrupt("return", {
                    response: response,
                    data: adjustedData
                  });

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData(_x, _x2) {
          return _onData.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  },
  update: function update(resource, params) {
    var _tokenizeVersionResou2 = tokenizeVersionResource(resource),
        model = _tokenizeVersionResou2.model;

    var args = [params.language, params.id, {
      comment: params.data
    }];
    return {
      method: "update".concat(model, "CommentOptions"),
      args: args,
      onData: function () {
        var _onData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, response) {
          var _data$constructor2;

          var adjustedData;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  adjustedData = ((_data$constructor2 = data.constructor) === null || _data$constructor2 === void 0 ? void 0 : _data$constructor2.constructFromObject({})) || {};
                  adjustedData.id = params.id;
                  adjustedData.options = _objectSpread2({}, data);
                  return _context2.abrupt("return", {
                    response: response,
                    data: adjustedData
                  });

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onData(_x3, _x4) {
          return _onData2.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    };
  }
});

var match$4 = function match(resource, params) {
  var isVersionResource = resource.indexOf('/comments') > -1;
  return isVersionResource && !!params.isOptions;
};
var commentOptionsClient$1 = Object.freeze(commentOptionsClient);

var getArgs = function getArgs() {
  var token = ApiClient.instance.authentications.oauth.accessToken;
  return {
    baseUrl: ApiClient.instance.basePath,
    headers: _objectSpread2(_objectSpread2({}, ApiClient.instance.defaultHeaders), {}, {
      Authorization: "Bearer ".concat(token)
    })
  };
};

var userManagementClient = _objectSpread2(_objectSpread2({}, bareClient$1), {}, {
  getUserPasswordResetToken: function getUserPasswordResetToken(resource, params) {
    return _objectSpread2(_objectSpread2({}, getArgs()), {}, {
      onData: function () {
        var _onData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onData(_x, _x2) {
          return _onData.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    });
  },
  resetUserPassword: function resetUserPassword(resource, params) {
    return _objectSpread2(_objectSpread2({}, getArgs()), {}, {
      onData: function () {
        var _onData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, response) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", {
                    response: response,
                    data: data
                  });

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onData(_x3, _x4) {
          return _onData2.apply(this, arguments);
        }

        return onData;
      }(),
      onError: errorParser
    });
  }
});

var managementClient = Object.freeze(userManagementClient);

/**
 * Every client represents data implementation per resource,
 * defaultClient is general implementation for most resources
 *
 * For more info on how each client is build check out
 * https://marmelab.com/react-admin/DataProviders.html
 *
 * @param {string} resource
 * @param {Object} params
 * @returns Object
 */

var getClient = function getClient(resource, params) {
  switch (resource) {
    case resource.indexOf('/state') > -1 ? resource : false:
      return stateClient$1;

    case match$4(resource, params) ? resource : false:
      return commentOptionsClient$1;

    case match$1(resource, params) ? resource : false:
      return optionsClient$1;

    case 'files':
    case 'videos':
      return fileClient$1;

    case match(resource) ? resource : false:
      return imageClient$1;

    case resource.indexOf('/config/') > -1 ? resource : false:
      return configClient$1;

    case 'users':
      return userClient$1;

    case 'tenant':
      return tenantClient$1;

    case resource.indexOf('attributes/') > -1 ? resource : false:
      return attributeClient$1;

    case resource.indexOf('comments') > -1 ? resource : false:
      return commentClient$1;

    case resource.indexOf('/versions') > -1 ? resource : false:
      return versionClient$1;

    case match$3(resource, params) ? resource : false:
      return contentSitemapNode;

    case match$2(resource, params) ? resource : false:
      return contentTaxon;

    case resource.indexOf('sitemaps/') > -1 ? resource : false:
    case resource.indexOf('taxonomies/') > -1 ? resource : false:
      return taxonomyClient$1;

    case 'management':
      return managementClient;

    default:
      return defaultClient$1;
  }
};

var apiList = {};
/**
 * Get api name, mostly will be handled by formatResourceName but some
 * cases may require resource based overrides
 *
 * @param {*} resource
 * @returns {string}
 */

var getApiName = function getApiName(resource) {
  switch (resource) {
    case resource.indexOf('related/') > -1 ? resource : false:
      return formatResourceName(resource.replace('related/', ''));

    case resource.indexOf('/comments') > -1 ? resource : false:
      return 'Comment';

    case resource.indexOf('images/config/') > -1 ? resource : false:
      return 'ImageConfig';

    default:
      return formatResourceName(resource);
  }
};
/**
 * Return valid API Client object for resource
 *
 * also caches API instances for further use after initial creation
 *
 * @param {*} resource
 * @returns {Object}
 */


var getApi = function getApi(resource) {
  var apiName = "".concat(getApiName(resource), "Api");

  try {
    if (!apiList[resource]) {
      if (!PodravkaClient[apiName]) {
        return null;
      }

      apiList[resource] = new PodravkaClient[apiName]();
    }

    return apiList[resource];
  } catch (e) {
    throw new Error("Resource name ".concat(resource, " is not supported by SDK"));
  }
};

var DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

// https://github.com/marmelab/react-admin/blob/710d3c1bedd0e89da0da8ef1ceb61b702557f804/packages/ra-core/src/dataProvider/useDataProvider.ts#L128

var createDataService = function createDataService() {
  var instance = {
    language: 'en',
    storageService: undefined,
    searchMappings: {},
    uniFetch: global.fetch
  };
  /**
   * Validate data provider method params
   * This could be expaneded with more rules
   *
   * @param {string} resource
   * @param {Object} params
   */

  var validate = function validate(resource) {

    if (!resource || typeof resource !== 'string') {
      throw new Error('resource param is required by dataProvider');
    }

    if (resource.startsWith('/')) {
      throw new Error("Resource name should not start with '/' symbol, you probably mean '".concat(resource.replace('/', ''), "'"));
    }
  };

  var enhanceClientParams = function enhanceClientParams(resource, params) {
    return _objectSpread2(_objectSpread2({}, params), {}, {
      language: instance.language,
      storageService: instance.storageService,
      searchMappings: params.searchMappings || instance.searchMappings
    });
  };

  var getList = function getList(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validate(resource);
    var api = getApi(resource);
    var client = getClient(resource, params);

    var _client$getList = client.getList(resource, enhanceClientParams(resource, params)),
        method = _client$getList.method,
        args = _client$getList.args,
        onData = _client$getList.onData,
        onError = _client$getList.onError;

    return new Promise(function (resolve, reject) {
      api[method].apply(api, _toConsumableArray(args).concat([/*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(error, data, response) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!error) {
                    _context.next = 7;
                    break;
                  }

                  _context.t0 = reject;
                  _context.next = 4;
                  return onError(error, response);

                case 4:
                  _context.t1 = _context.sent;
                  (0, _context.t0)(_context.t1);
                  return _context.abrupt("return");

                case 7:
                  _context.t2 = resolve;
                  _context.next = 10;
                  return onData(data, response);

                case 10:
                  _context.t3 = _context.sent;
                  (0, _context.t2)(_context.t3);

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }()]));
    });
  };

  var getOne = function getOne(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validate(resource);
    var api = getApi(resource);
    var client = getClient(resource, params);

    var _client$getOne = client.getOne(resource, enhanceClientParams(resource, params)),
        method = _client$getOne.method,
        args = _client$getOne.args,
        onData = _client$getOne.onData,
        onError = _client$getOne.onError;

    return new Promise(function (resolve, reject) {
      api[method].apply(api, _toConsumableArray(args).concat([/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(error, data, response) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!error) {
                    _context2.next = 7;
                    break;
                  }

                  _context2.t0 = reject;
                  _context2.next = 4;
                  return onError(error, response);

                case 4:
                  _context2.t1 = _context2.sent;
                  (0, _context2.t0)(_context2.t1);
                  return _context2.abrupt("return");

                case 7:
                  _context2.t2 = resolve;
                  _context2.next = 10;
                  return onData(data, response);

                case 10:
                  _context2.t3 = _context2.sent;
                  (0, _context2.t2)(_context2.t3);

                case 12:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x4, _x5, _x6) {
          return _ref2.apply(this, arguments);
        };
      }()]));
    });
  };

  var create = function create(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validate(resource);
    var api = getApi(resource);
    var client = getClient(resource, params);

    var _client$create = client.create(resource, enhanceClientParams(resource, params)),
        method = _client$create.method,
        args = _client$create.args,
        onData = _client$create.onData,
        onError = _client$create.onError;

    return new Promise(function (resolve, reject) {
      api[method].apply(api, _toConsumableArray(args).concat([/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(error, data, response) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!error) {
                    _context3.next = 7;
                    break;
                  }

                  _context3.t0 = reject;
                  _context3.next = 4;
                  return onError(error, response);

                case 4:
                  _context3.t1 = _context3.sent;
                  (0, _context3.t0)(_context3.t1);
                  return _context3.abrupt("return");

                case 7:
                  _context3.t2 = resolve;
                  _context3.next = 10;
                  return onData(data, response);

                case 10:
                  _context3.t3 = _context3.sent;
                  (0, _context3.t2)(_context3.t3);

                case 12:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x7, _x8, _x9) {
          return _ref3.apply(this, arguments);
        };
      }()]));
    });
  };

  var update = function update(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validate(resource);
    var api = getApi(resource);
    var client = getClient(resource, params);

    var _client$update = client.update(resource, enhanceClientParams(resource, params)),
        method = _client$update.method,
        args = _client$update.args,
        onData = _client$update.onData,
        onError = _client$update.onError;

    return new Promise(function (resolve, reject) {
      api[method].apply(api, _toConsumableArray(args).concat([/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(error, data, response) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!error) {
                    _context4.next = 7;
                    break;
                  }

                  _context4.t0 = reject;
                  _context4.next = 4;
                  return onError(error, response);

                case 4:
                  _context4.t1 = _context4.sent;
                  (0, _context4.t0)(_context4.t1);
                  return _context4.abrupt("return");

                case 7:
                  _context4.t2 = resolve;
                  _context4.next = 10;
                  return onData(data, response);

                case 10:
                  _context4.t3 = _context4.sent;
                  (0, _context4.t2)(_context4.t3);

                case 12:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x10, _x11, _x12) {
          return _ref4.apply(this, arguments);
        };
      }()]));
    });
  };

  var deleteOne = function deleteOne(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validate(resource);
    var api = getApi(resource);
    var client = getClient(resource, params);

    var _client$delete = client["delete"](resource, enhanceClientParams(resource, params)),
        method = _client$delete.method,
        args = _client$delete.args,
        onData = _client$delete.onData,
        onError = _client$delete.onError;

    return new Promise(function (resolve, reject) {
      api[method].apply(api, _toConsumableArray(args).concat([/*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(error, data, response) {
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!error) {
                    _context5.next = 7;
                    break;
                  }

                  _context5.t0 = reject;
                  _context5.next = 4;
                  return onError(error, response);

                case 4:
                  _context5.t1 = _context5.sent;
                  (0, _context5.t0)(_context5.t1);
                  return _context5.abrupt("return");

                case 7:
                  _context5.t2 = resolve;
                  _context5.next = 10;
                  return onData(data, response);

                case 10:
                  _context5.t3 = _context5.sent;
                  (0, _context5.t2)(_context5.t3);

                case 12:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x13, _x14, _x15) {
          return _ref5.apply(this, arguments);
        };
      }()]));
    });
  };

  var deleteMany = function deleteMany(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    try {
      var ids = params.ids,
          _params$resources = params.resources,
          resources = _params$resources === void 0 ? [] : _params$resources;
      return Promise.allSettled( // eslint-disable-next-line no-console
      ids.map(function (id, index) {
        return deleteOne(resources[index] || resource, {
          id: id
        });
      })).then(function (responses) {
        return responses.reduce(function (acc, _ref6, index) {
          var status = _ref6.status,
              reason = _ref6.reason;

          if (status === 'fulfilled') {
            acc.data.push(ids[index]);
          } else {
            acc.errors.push(reason);
          }

          return acc;
        }, {
          data: [],
          errors: []
        });
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      throw new Error('deleteMany method is not supported');
    }
  };

  var getMany = function getMany(resource, params) {
    try {
      var ids = params.ids,
          _params$resources2 = params.resources,
          resources = _params$resources2 === void 0 ? [] : _params$resources2;
      return Promise.allSettled( // eslint-disable-next-line no-console
      ids.map(function (id, index) {
        return getOne(resources[index] || resource, {
          id: id
        });
      })).then(function (responses) {
        return responses.reduce(function (acc, _ref7, index) {
          var status = _ref7.status,
              value = _ref7.value,
              reason = _ref7.reason;

          if (status === 'fulfilled' && (value === null || value === void 0 ? void 0 : value.data)) {
            acc.data.push(value.data);
          } else {
            acc.errors.push(reason);
          }

          return acc;
        }, {
          data: [],
          errors: []
        });
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      throw new Error('getMany method is not supported');
    }
  };

  var getListTaxon = function getListTaxon(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validate(resource);
    var api = getApi(resource);
    var client = getClient(resource, params);

    var _client$getList2 = client.getList(resource, enhanceClientParams(resource, params)),
        method = _client$getList2.method,
        args = _client$getList2.args,
        onData = _client$getList2.onData,
        onError = _client$getList2.onError;

    return new Promise(function (resolve, reject) {
      api[method].apply(api, _toConsumableArray(args).concat([/*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(error, data, response) {
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!error) {
                    _context6.next = 7;
                    break;
                  }

                  _context6.t0 = reject;
                  _context6.next = 4;
                  return onError(error, response);

                case 4:
                  _context6.t1 = _context6.sent;
                  (0, _context6.t0)(_context6.t1);
                  return _context6.abrupt("return");

                case 7:
                  _context6.t2 = resolve;
                  _context6.next = 10;
                  return onData(data, response);

                case 10:
                  _context6.t3 = _context6.sent;
                  (0, _context6.t2)(_context6.t3);

                case 12:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x16, _x17, _x18) {
          return _ref8.apply(this, arguments);
        };
      }()]));
    });
  };

  var getManyReference = function getManyReference(resource, params) {
    var id = params.id,
        target = params.target,
        filter = params.filter,
        rest = _objectWithoutProperties(params, ["id", "target", "filter"]);

    var _ref9 = filter || {},
        bag = _ref9.bag,
        restFilter = _objectWithoutProperties(_ref9, ["bag"]);

    return getListTaxon(resource, _objectSpread2({
      entity: target,
      entityId: id,
      bag: bag,
      filter: restFilter
    }, rest));
  };

  var updateMany = function updateMany(resource, params) {
    try {
      var ids = params.ids,
          _params$resources3 = params.resources,
          resources = _params$resources3 === void 0 ? [] : _params$resources3;
      return Promise.allSettled( // eslint-disable-next-line no-console
      ids.map(function (id, index) {
        return update(resources[index] || resource, {
          id: id,
          data: params.data
        });
      })).then(function (responses) {
        return responses.reduce(function (acc, _ref10, index) {
          var status = _ref10.status,
              reason = _ref10.reason;

          if (status === 'fulfilled') {
            acc.data.push(ids[index]);
          } else {
            acc.errors.push(reason);
          }

          return acc;
        }, {
          data: [],
          errors: []
        });
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      throw new Error('updateMany method is not supported');
    }
  };

  var getOneTaxon = function getOneTaxon(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validate(resource);
    var api = getApi(resource);
    var client = getClient(resource, params);

    var _client$getOne2 = client.getOne(resource, enhanceClientParams(resource, params)),
        method = _client$getOne2.method,
        args = _client$getOne2.args,
        onData = _client$getOne2.onData,
        onError = _client$getOne2.onError;

    return new Promise(function (resolve, reject) {
      api[method].apply(api, _toConsumableArray(args).concat([/*#__PURE__*/function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(error, data, response) {
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!error) {
                    _context7.next = 7;
                    break;
                  }

                  _context7.t0 = reject;
                  _context7.next = 4;
                  return onError(error, response);

                case 4:
                  _context7.t1 = _context7.sent;
                  (0, _context7.t0)(_context7.t1);
                  return _context7.abrupt("return");

                case 7:
                  _context7.t2 = resolve;
                  _context7.next = 10;
                  return onData(data, response);

                case 10:
                  _context7.t3 = _context7.sent;
                  (0, _context7.t2)(_context7.t3);

                case 12:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x19, _x20, _x21) {
          return _ref11.apply(this, arguments);
        };
      }()]));
    });
  };

  var createTaxon = function createTaxon(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validate(resource);
    var api = getApi(resource);
    var client = getClient(resource, params);

    var _client$create2 = client.create(resource, enhanceClientParams(resource, params)),
        method = _client$create2.method,
        args = _client$create2.args,
        onData = _client$create2.onData,
        onError = _client$create2.onError;

    return new Promise(function (resolve, reject) {
      api[method].apply(api, _toConsumableArray(args).concat([/*#__PURE__*/function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(error, data, response) {
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  if (!error) {
                    _context8.next = 7;
                    break;
                  }

                  _context8.t0 = reject;
                  _context8.next = 4;
                  return onError(error, response);

                case 4:
                  _context8.t1 = _context8.sent;
                  (0, _context8.t0)(_context8.t1);
                  return _context8.abrupt("return");

                case 7:
                  _context8.t2 = resolve;
                  _context8.next = 10;
                  return onData(data, response);

                case 10:
                  _context8.t3 = _context8.sent;
                  (0, _context8.t2)(_context8.t3);

                case 12:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x22, _x23, _x24) {
          return _ref12.apply(this, arguments);
        };
      }()]));
    });
  };

  var deleteTaxon = function deleteTaxon(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validate(resource);
    var api = getApi(resource);
    var client = getClient(resource, params);

    var _client$delete2 = client["delete"](resource, enhanceClientParams(resource, params)),
        method = _client$delete2.method,
        args = _client$delete2.args,
        onData = _client$delete2.onData,
        onError = _client$delete2.onError;

    return new Promise(function (resolve, reject) {
      api[method].apply(api, _toConsumableArray(args).concat([/*#__PURE__*/function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(error, data, response) {
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  if (!error) {
                    _context9.next = 7;
                    break;
                  }

                  _context9.t0 = reject;
                  _context9.next = 4;
                  return onError(error, response);

                case 4:
                  _context9.t1 = _context9.sent;
                  (0, _context9.t0)(_context9.t1);
                  return _context9.abrupt("return");

                case 7:
                  _context9.t2 = resolve;
                  _context9.next = 10;
                  return onData(data, response);

                case 10:
                  _context9.t3 = _context9.sent;
                  (0, _context9.t2)(_context9.t3);

                case 12:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        return function (_x25, _x26, _x27) {
          return _ref13.apply(this, arguments);
        };
      }()]));
    });
  };

  var getUserPasswordResetToken = function getUserPasswordResetToken(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var client = getClient(resource, params);

    var _client$getUserPasswo = client.getUserPasswordResetToken(resource, params),
        baseUrl = _client$getUserPasswo.baseUrl,
        headers = _client$getUserPasswo.headers,
        onData = _client$getUserPasswo.onData,
        onError = _client$getUserPasswo.onError;

    var email = params.email;
    var uniFetch = instance.uniFetch;

    var getResetToken = /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var response, data, result;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return uniFetch("".concat(baseUrl, "/").concat(resource, "/users/password-reset/token"), {
                  method: 'POST',
                  headers: headers,
                  body: JSON.stringify({
                    email: email
                  })
                });

              case 3:
                response = _context10.sent;
                _context10.next = 6;
                return response.json();

              case 6:
                data = _context10.sent;
                _context10.next = 9;
                return onData(data, response);

              case 9:
                result = _context10.sent;
                return _context10.abrupt("return", result);

              case 13:
                _context10.prev = 13;
                _context10.t0 = _context10["catch"](0);
                _context10.next = 17;
                return onError(_context10.t0, response);

              case 17:
                throw _context10.sent;

              case 18:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 13]]);
      }));

      return function getResetToken() {
        return _ref14.apply(this, arguments);
      };
    }();

    return getResetToken();
  };

  var resetUserPassword = function resetUserPassword(resource) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var client = getClient(resource, params);

    var _client$resetUserPass = client.resetUserPassword(resource, params),
        headers = _client$resetUserPass.headers,
        baseUrl = _client$resetUserPass.baseUrl,
        onData = _client$resetUserPass.onData,
        onError = _client$resetUserPass.onError;

    var password = params.password,
        passwordResetToken = params.token;
    var uniFetch = instance.uniFetch;

    var resetPasword = /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var response, data, result;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return uniFetch("".concat(baseUrl, "/").concat(resource, "/users/password-reset/change"), {
                  method: 'POST',
                  headers: headers,
                  body: JSON.stringify({
                    token: passwordResetToken,
                    password: password
                  })
                });

              case 3:
                response = _context11.sent;
                _context11.next = 6;
                return response.json();

              case 6:
                data = _context11.sent;
                _context11.next = 9;
                return onData(data, response);

              case 9:
                result = _context11.sent;
                return _context11.abrupt("return", result);

              case 13:
                _context11.prev = 13;
                _context11.t0 = _context11["catch"](0);
                throw onError(_context11.t0, response);

              case 16:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 13]]);
      }));

      return function resetPasword() {
        return _ref15.apply(this, arguments);
      };
    }();

    return resetPasword();
  };

  return {
    /**
     * Used for passing params to module wrapped by service
     *
     * @param {Object} { baseUrl, token, storageService, language }
     */
    init: function init(_ref16) {
      var baseUrl = _ref16.baseUrl,
          token = _ref16.token,
          storageService = _ref16.storageService,
          language = _ref16.language,
          _ref16$uniFetch = _ref16.uniFetch,
          uniFetch = _ref16$uniFetch === void 0 ? global.fetch : _ref16$uniFetch;
      ApiClient.instance.basePath = baseUrl;
      ApiClient.instance.authentications.oauth.accessToken = token; // merge headers from SDK with default headers for data provider

      ApiClient.instance.defaultHeaders = _objectSpread2(_objectSpread2({}, ApiClient.instance.defaultHeaders), DEFAULT_HEADERS);

      if (!storageService) {
        // eslint-disable-next-line no-console
        console.warn('storageService is not provided, upload capabilities will not work');
      } else {
        instance.storageService = storageService;
      }

      instance.language = language;
      instance.uniFetch = uniFetch;
    },

    /**
     * Get token
     *
     * @returns string
     */
    getToken: function getToken() {
      return ApiClient.instance.authentications.oauth.accessToken;
    },

    /**
     * Set token
     *
     * @param {string} token
     */
    setToken: function setToken(token) {
      ApiClient.instance.authentications.oauth.accessToken = token;
    },

    /**
     * Get language
     *
     * @returns string
     */
    getLanguage: function getLanguage() {
      return instance.language;
    },

    /**
     * Set language
     *
     * @param {string} language
     */
    setLanguage: function setLanguage(language) {
      instance.language = language;
    },

    /**
     * Get searchMappings
     *
     * @returns Object
     */
    getSearchMappings: function getSearchMappings() {
      return instance.searchMappings;
    },

    /**
     * Set searchMappings
     *
     * @param {Object} searchMappings
     */
    setSearchMappings: function setSearchMappings(searchMappings) {
      instance.searchMappings = searchMappings || {};
    },
    getList: getList,
    getOne: getOne,
    create: create,
    update: update,
    "delete": deleteOne,
    getMany: getMany,
    getManyReference: getManyReference,
    updateMany: updateMany,
    deleteMany: deleteMany,
    getListTaxon: getListTaxon,
    getOneTaxon: getOneTaxon,
    createTaxon: createTaxon,
    deleteTaxon: deleteTaxon,
    getUserPasswordResetToken: getUserPasswordResetToken,
    resetUserPassword: resetUserPassword
  };
};

var DataService = createDataService();

/**
 * Service used for accesing and manipulating AWS S3 blob storage
 *
 * @returns
 */
var createAwsS3StorageService = function createAwsS3StorageService() {
  var instance = {};
  /**
   * Upload file to AWS S3 blob storage
   *
   * @param {Object} { id, resource, file, uploadLocation: containerUrl }
   */

  var upload = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var id, resource, file, bucketUrl;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = _ref.id, resource = _ref.resource, file = _ref.file, bucketUrl = _ref.uploadLocation;

              if (file === null || file === void 0 ? void 0 : file.rawFile) {
                _context.next = 3;
                break;
              }

              throw new Error('Item provided for upload is not a valid File');

            case 3:
              if (bucketUrl) {
                _context.next = 5;
                break;
              }

              throw new Error('uploadLocation is required');

            case 5:
              _context.prev = 5;
              _context.next = 8;
              return instance.fetch(bucketUrl, {
                method: 'PUT',
                body: file.rawFile
              });

            case 8:
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](5);
              // eslint-disable-next-line no-console
              console.error(_context.t0);
              throw new Error('Upload failed', _context.t0.message);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 10]]);
    }));

    return function upload(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return Object.freeze({
    /**
     * Init method, JavaScript fetch method (or polyfill) is required
     *
     * @param {Object} { fetch: fetchInstance }
     */
    init: function init(_ref3) {
      var fetchInstance = _ref3.fetch;

      instance.fetch = function () {
        return fetchInstance.apply(void 0, arguments);
      };
    },
    upload: upload,
    isEnabled: function isEnabled() {
      return !!instance.fetch;
    }
  });
};

var AwsS3StorageService = createAwsS3StorageService();

// import PioConfigProvider from '../components/auth-flows/podravka-io/PioConfigProvider'

export default DataService;
export { AwsS3StorageService, AzureStorageService, DEFAULT_HEADERS, DataService, SearchEnum, SearchQuery };
